import { gql } from '@apollo/client'
import { ErrandCreateInput, useCreateErrandMutation } from '@graphql/generated'

gql`
  mutation CreateErrand($input: ErrandCreateInput!) {
    errandCreate(input: $input) {
      error
    }
  }
`

export const useCreateErrand = () => {
  const [errandCreate] = useCreateErrandMutation()

  const handleCreateErrand = (input: ErrandCreateInput) =>
    errandCreate({
      variables: {
        input,
      },
    })

  return {
    createErrand: handleCreateErrand,
  }
}
